<template>
  <div>
    <div class="w-20 border-t-4 border-n3yellow my-10"></div>
    <div class="page-heading">Privacy Policy</div>

    <div class="space-y-8 page-content">
      <div>Effective Date: January 23, 2023</div>
      <address>
        N3 GmbH <br />
        Xantener Straße 7<br />
        41460 Neuss <br />Germany
      </address>

      <p>
        At N3 GmbH, we prioritize data privacy and place great importance on
        protecting your personal information and preserving your privacy. In
        this Privacy Policy, we aim to inform you about how we collect, use, and
        safeguard your data both on our website n3.app and within our app.
      </p>
      <p>
        Data Collection and Usage To provide you with our services optimally and
        offer a personalized experience, we collect various types of data. This
        may include your registration details such as your name, email address,
        and other relevant information. We use this information solely to grant
        you access to our services and to keep you informed about important
        updates and news.
      </p>

      <p>
        Newsletter Subscription During registration, as a user, you have the
        option to subscribe to our newsletter. The newsletter will regularly
        update you on current offers and upcoming events. Subscribing to the
        newsletter is voluntary, and you can opt-out at any time by sending an
        email to support@n3.app. Your data will be promptly deleted upon
        request.
      </p>

      <p>
        Data Security We implement state-of-the-art security measures to protect
        your data from unauthorized access, misuse, or loss. Both our website
        and app undergo regular security assessments and are safeguarded
        accordingly.
      </p>

      <p>
        Data Sharing with Third Parties We generally do not disclose your
        personal data to third parties, unless required by law or necessary for
        the provision of our services. In such cases, we will treat your data
        with utmost care and confidentiality. Our partners or service providers
        who may require access to your data will be contractually obliged to
        handle your information in compliance with applicable data protection
        laws and solely for the agreed-upon purposes. We will never sell or
        share your data with third parties for marketing purposes. Your privacy
        is important to us, and we strive to ensure the best protection for your
        data.
      </p>
      <p>
        Cookies and Analytical Tools Both on our website and in our app, we use
        cookies and similar technologies to enhance your user experience.
        Cookies are small text files stored on your device, containing
        information about your interactions with our platform. Analytical tools
        help us understand user behavior and optimize our services accordingly.
        You have the option to disable cookies in your browser settings, but
        please note that this may limit the functionality of our offerings.
      </p>
      <p>
        Changes to this Privacy Policy We reserve the right to modify this
        Privacy Policy at any time. Changes will be posted on our website and
        within our app, so we recommend checking regularly to stay up-to-date.
      </p>
      <p>
        Questions and Contact If you have any questions or concerns regarding
        data privacy, please feel free to contact us at support@n3.app.
      </p>
      <p>
        Thank you for placing your trust in N3 GmbH. We wish you a delightful
        experience while using our website and app!
      </p>
    </div>
  </div>
</template>
<script>
import { onMounted } from "vue";
import { scrollToTop } from "@/utils/helper";
import { useMeta } from "vue-meta";
export default {
  setup() {
    useMeta({
      title: "Privacy Policy",
    });
    onMounted(() => {
      scrollToTop();
    });
  },
};
</script>
